import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import MobilePopUp from '../../components/MobilePopUp/MobilePopUp';
import { toaster } from '../../utils/utils'
import apiConstants from '../../constans/apiConstants';
import DataTable from '../../components/Table';
import YesNoRadioButton from '../../components/YesNoRadioButton';

const InstaVerifyList = () => {
    const [proposalNumber, setProposal] = useState({
        partnerName: '',
        subChannel: '',
        channel: '',
        sources: ''
    });
    const [showEditModal, setshowEditModal] = useState(false);
    const [data, setData] = useState()
    const [apiPaymantOption, setApiPayment] = useState()
    // const [options, setOptions] = useState({
    //     initialPaymentOptions: [
    //         { value: "CASH|Cash", active: true },
    //         { value: "CHEQUE|Cheque", active: false },
    //         { value: "DEMAND_DRAFT|Demand draft", active: false },
    //         { value: "NEFT|NEFT", active: false },
    //         { value: "ONLINE_LINK|Online link", active: false },
    //         { value: "ONLINE_BILL_DESK|Online Payment", active: false },
    //         { value: "PAYMENT_AT_BANK_CHEQUE|Pay at bank cheque", active: false },
    //         { value: "PAYMENT_AT_BANK_CASH|Pay at bank cash", active: false },
    //         { value: "FUND_TRANSFER|Fund Transfer", active: false }],
    //     initialPaymentAtBankOptions: [
    //         { value: "ALLAHABAD_BANK|Allahabad Bank", active: false },
    //         { value: "YES_BANK|Yes Bank", active: false },
    //         { value: "AXIS_BANK|Axis Bank", active: false },
    //         { value: "KBL_BANK|Karnataka Bank", active: false },
    //         { value: "SBM_BANK|State Bank of Mauritius", active: false }],
    //     initialPaymentMonthlyModeOptions: [
    //         { value: "ONE_MONTH|One Month", active: false },
    //         { value: "TWO_MONTHS|Two Months", active: false }],
    //     renewalPaymentAnnualFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    //     renewalPaymentSemiAnnualFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    //     renewalPaymentQuarterlyFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    //     renewalPaymentMonthlyFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    // })
    const [options, setOptions] = useState({
        initialPaymentOptions: ["CASH|Cash", "CHEQUE|Cheque", "DEMAND_DRAFT|Demand draft", "NEFT|NEFT", "ONLINE_LINK|Online link", "ONLINE_BILL_DESK|Online Payment", "PAYMENT_AT_BANK_CHEQUE|Pay at bank cheque", "PAYMENT_AT_BANK_CASH|Pay at bank cash", "FUND_TRANSFER|Fund Transfer", "DIRECT_DEBIT|Direct Debit", "FINCARE_BANK|Fincare Bank"],
        initialPaymentAtBankOptions: ["HDFC_BANK|Hdfc Bank", "ALLAHABAD_BANK|Allahabad Bank", "YES_BANK|Yes Bank", "AXIS_BANK|Axis Bank", "KBL_BANK|Karnataka Bank", "SBM_BANK|State Bank of Mauritius"],
        initialPaymentMonthlyModeOptions: ["ONE_MONTH|One Month", "TWO_MONTHS|Two Months"],
        renewalPaymentAnnualFrequencyOptions: ["CASH|Cash", "CHEQUE|Cheque", "ECS_ACH|ECS/ACH", "E_MANDATE|Send E-mandate Link to Customer"],
        renewalPaymentSemiAnnualFrequencyOptions: ["CASH|Cash", "CHEQUE|Cheque", "ECS_ACH|ECS/ACH", "E_MANDATE|Send E-mandate Link to Customer"],
        renewalPaymentQuarterlyFrequencyOptions: ["CASH|Cash", "CHEQUE|Cheque", "ECS_ACH|ECS/ACH", "E_MANDATE|Send E-mandate Link to Customer"],
        renewalPaymentMonthlyFrequencyOptions: ["CASH|Cash", "CHEQUE|Cheque", "ECS_ACH|ECS/ACH", "E_MANDATE|Send E-mandate Link to Customer"]
    })
    const dispatch = useDispatch();
    const inputHandler = (e, item) => {
        const data = {
            ...proposalNumber,
            [item]: e.target.value
        }
        setProposal(data)
    }

    const set_payemtOptions = (data) => {

        setApiPayment(data)
    }
    const getAllItem = () => {
        const { partnerName, subChannel, channel, sources } = proposalNumber;
        const param = `partnerName=${partnerName}&subChannel=${subChannel}&channel=${channel}&sources=${sources}`
        const queryParam = param ? param : "partnerName&subChannel&channel&sources"
        axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/instaVerify/instaRuleSheet?${queryParam}
        `, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem('token'),
            }
        }).then((res) => {
            dispatch({ type: 'LOADER_FALSE' })
            if (res && res.data) {
                setData(res.data)
                toaster('success', res.data.message)
            }
        }).catch((err) => {
            dispatch({ type: 'LOADER_FALSE' });
            if (err && err.data) {
                toaster('error', err.data.message)
            }
        })
    }

    const handleConfig = (name, key, value) => {
        value = key === "yes"
        let id;
        if (typeof name === 'string' && (name.includes('term') || name.includes('savings') || name.includes('consentRequired') || name.includes('agentConsentRequired') || name.includes('neftpayment') || name.includes('cashPayment') || name.includes('issuanceType') || name.includes('accountAggregator'))) {
            const data = name.split(" ");
            id = data && data[0]
            name = data && data[1]
        }
        const dataItem = data.body.filter((item) => {
            return item.id == id;
        })
        if (name === "issuanceType") {
            value = key === "yes" ? "EASE" : "NEWGEN"
        }
        let updatedItem = {
            ...dataItem[0],
            [name]: value
        }

        updateInsta(updatedItem)
    }
    const updateInsta = (updatedItem) => {
        axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/instaVerify/update-insta-rule
    `, updatedItem, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem('token'),
            }
        })
            .then((res) => {
                dispatch({ type: 'LOADER_FALSE' })
                if (res && res.data) {
                    getAllItem();
                    toaster('success', res.data.message)
                }
            })
            .catch((err) => {
                dispatch({ type: 'LOADER_FALSE' });
                if (err && err.data) {
                    toaster('error', err.data.message)
                }
            })
    }
    const setComponent = (item, key) => {
        let type = item[key] === true || item[key] === 'EASE' ? "yes" : "no";
        return (item.channel === 'AGENCY' && key !== "issuanceType" && key !== "consentRequired" && key !== "agentConsentRequired" && key !== "neftpayment" && key !== "cashPayment" && key !== 'accountAggregator' ? 'NA*' :
            <YesNoRadioButton
                handleChange={(name, key, value) => {
                    handleConfig(name, key, value)
                }}
                rules={{
                    editable: true,
                }}
                yesValue={"yes"}
                noValue={"no"}
                checked={type}
                issuanceType={key === "issuanceType"}
                dataname={key === 'savings' ? item.id + ' savings' : key === "term" ? item.id + " term" : key === "neftpayment" ? item.id + " neftpayment" : key === "cashPayment" ? item.id + " cashPayment" : key === "consentRequired" ? item.id + " consentRequired" : key === "issuanceType" ? item.id + " issuanceType" : key==='accountAggregator'? item.id + ' accountAggregator' : item.id + " agentConsentRequired"}
            />)
    }

    useEffect(() => {
        getAllItem();
    }, [])

    const search = (e) => {
        e.preventDefault()
        getAllItem()
    }
    const paymentMethodChange = (item, type) => {
        const apiData = JSON.parse(JSON.stringify(apiPaymantOption))
        if (apiData[type] && apiData[type]?.includes(item)) {
            apiData[type] = apiData[type].filter((val) => val !== item);
        } else {
            apiData[type] && apiData[type].push(item);
        }
        setApiPayment({
            ...apiData
        })

    }
    const submitOptions = () => {
        updateInsta(apiPaymantOption)
    }
    return (
        <div className="downloads_comp instaverify_comp">
            <div>Enter Proposal Data </div>
            <div className="tabSelection">
                <form>
                    <div className="tabSelection input-fields-wrapper">
                        <input onChange={(e) => inputHandler(e, 'partnerName')}
                            value={proposalNumber.partnerName}
                            className={`input-field`}
                            type="text"
                            placeholder="Partner Name"
                            name="proposal" />
                    </div>
                    <div className="tabSelection input-fields-wrapper">
                        <input onChange={(e) => inputHandler(e, 'subChannel')}
                            value={proposalNumber.subChannel}
                            className={`input-field`}
                            type="text"
                            placeholder="Sub Channel"
                            name="subChanel" />
                    </div>
                    <div className="tabSelection input-fields-wrapper">
                        <input onChange={(e) => inputHandler(e, 'channel')}
                            value={proposalNumber.channel}
                            className={`input-field`}
                            type="text"
                            placeholder="channel"
                            name="channel" />
                    </div>
                    <div className="tabSelection input-fields-wrapper">
                        <input onChange={(e) => inputHandler(e, 'sources')}
                            value={proposalNumber.sources}
                            className={`input-field`}
                            type="text"
                            placeholder="sources"
                            name="sources" />
                    </div>
                    <button className="searchbt" onClick={search}>
                        Search
                    </button>
                </form>

            </div>
            <div className="operations_comp">
                {data && data.body && <DataTable
                    cellHeaders={['channel', 'channelGroup','partnerName', 'neftpayment', 'savings', 'sources', 'subChannel', 'term','Ease/NewGen','Account Aggregator'
                    ]}
                    data={data.body}
                    keys={['channel','channelGroup', 'partnerName', 'neftpayment', 'savings', 'sources', 'subChannel', 'term','issuanceType','accountAggregator'
                    ]}
                    addSerialNo={true}
                    PerPageApiData={false}
                    converTdToComponent={'term'}
                    secondconverTdToComponent={'savings'}
                    thirdconverTdToComponent={'consentRequired'}
                    fourthconverTdToComponent={"neftpayment"}
                    fifthconvertTdToComponent={"cashPayment"}
                    sixthconvertTdToComponent={"agentConsentRequired"}
                    seventhconvertTdToComponent={'issuanceType'}
                    AAconvertTdToComponent={'accountAggregator'}
                    componentToBeConverted={setComponent}
                    paginationItems={data.body}
                    alwaysShown={false}
                    onCustomButtonClick={(item) => {
                        setshowEditModal(true);
                        set_payemtOptions(item)
                    }}
                />}
            </div>
            <div className="note-text">
                <div className="note-title">* Note -</div>
                <div className="note-points">
                    <div>1. The Proposal with the Channel name as 'AGENCY' & Sub Channel name as 'PP', Insta2.0 will be triggered. </div>
                    <div>2. The Proposal with the Channel name as 'AGENCY' & Coverage Annualized Premium value less than Rs. 30,000, Insta2.0 will be triggered. </div>
                </div>
            </div>
            {showEditModal && (
                <MobilePopUp onClose={() => {
                    setshowEditModal(false);
                }}>
                    <div className='paymentOptions'>
                        <h2>PAYMENT OPTIONS:</h2>
                        {
                            Object.keys(options).map((methods, i) => {

                                return (
                                    <>
                                        {options[methods].length > 0 && <h3>{methods}</h3>}
                                        <div className="pay_options">
                                            {options[methods]?.map((item, key) => {
                                                return (
                                                    <button className={`${apiPaymantOption[methods]?.includes(item) ? 'activebt' : ''} options_name`} key={key} onClick={(e) => paymentMethodChange(item, methods)}>{item.split('|') && item.split('|')[1]}</button>
                                                )

                                            })}
                                        </div>
                                    </>
                                )
                            })
                        }
                        <button onClick={submitOptions}>Submit</button>
                    </div>
                </MobilePopUp>
            )
            }
        </div >
    )
}

export default InstaVerifyList;
